import { Component, ViewEncapsulation } from '@angular/core';
import { FeatureDetectService, MddHttpService, UrlService } from './core';
import { CustomIconService } from './util/custom-icon.service';

import './extendElementPrototypeExportHtmlToString.js';
@Component({
    selector: 'mdd-root',
    templateUrl: 'app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AppComponent {
    constructor(
        features: FeatureDetectService,
        mddHttp: MddHttpService,
        private customIconService: CustomIconService
    ) {
        features.detectFeatures();
        const w = window as any;
        w.mdd = w.mdd || {};
        w.mdd.elements = w.mdd.elements || {};
        w.mdd.elements.http = mddHttp;
        this.customIconService.init();
    }
}
